import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgSparkle = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m21.61 14.116-5.64-2.086-2.08-5.645a1.74 1.74 0 0 0-3.268 0L8.53 12.031 2.885 14.11a1.74 1.74 0 0 0 0 3.269l5.646 2.09 2.078 5.647a1.741 1.741 0 0 0 3.268 0l2.092-5.646 5.646-2.078a1.741 1.741 0 0 0 0-3.268l-.005-.007Zm-6.626 3.846a.874.874 0 0 0-.518.518l-2.216 6.004-2.212-6a.876.876 0 0 0-.522-.522l-6-2.212 6-2.212a.875.875 0 0 0 .522-.522l2.212-6 2.212 6a.873.873 0 0 0 .518.518l6.004 2.216-6 2.212Zm.766-13.587a.875.875 0 0 1 .875-.875h1.75V1.75a.875.875 0 0 1 1.75 0V3.5h1.75a.875.875 0 1 1 0 1.75h-1.75V7a.875.875 0 0 1-1.75 0V5.25h-1.75a.875.875 0 0 1-.875-.875Zm11.375 5.25a.875.875 0 0 1-.875.875h-.875v.875a.875.875 0 1 1-1.75 0V10.5h-.875a.875.875 0 1 1 0-1.75h.875v-.875a.875.875 0 0 1 1.75 0v.875h.875a.875.875 0 0 1 .875.875Z" />
  </svg>
);
export default SvgSparkle;
